export default "__VITE_ASSET__ECuDPCn1__"